import React, { Component, forwardRef } from 'react'
import './custom-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from "react-redux";
import * as auth from "../../store/ducks/auth.duck";
import { createStyles, makeStyles, withStyles, Theme } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Divider } from '@material-ui/core';
import UserApi from '../../api/Scoreboardapi';
import { Link } from "react-router-dom";
import SweetAlert from 'react-bootstrap-sweetalert';
import Modal from './Modal';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import NativeSelect from '@material-ui/core/NativeSelect';
import FormControl from '@material-ui/core/FormControl';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import InputBase from '@material-ui/core/InputBase';
import MaterialTable, { MTableAction } from "material-table";
import Footer from '../auth/Footer';
import { Helmet } from 'react-helmet'
import moment from 'moment';

import MenuLeftNav from './MenuLeftNav';
import { checkModulePermission } from "../../crud/auth.crud";
import { CropPortrait } from '@material-ui/icons';

const REACT_APP_API_IMAGE_URL = process.env.REACT_APP_API_IMAGE_URL || '/';

library.add(fas)

// Styles
const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} color="primary" ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} color="primary" ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const BootstrapInput = withStyles((theme: Theme) =>
    createStyles({
        root: {
            'label + &': {
                marginTop: theme.spacing(3),
            },
        },
        input: {
            borderRadius: 4,
            position: 'relative',
            backgroundColor: theme.palette.background.paper,
            border: '1px solid #ced4da',
            fontSize: 16,
            padding: '10px 26px 10px 12px',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            // Use the system font instead of the default Roboto font.
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            '&:focus': {
                borderRadius: 4,
                borderColor: '#80bdff',
                boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
            },
        },
    }),
)(InputBase);

// Logos = referrals components
class Logos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            currentSortOrder: { defaultSort: "asc" },
            sortBy: "referral",
            isLoading: false,
            nameSort: {},
            textToSearch: '',
            rowsPerPage: 10,
            totalRecords: 10,
            rowsToSkip: 0,
            alert: '',
            hidepageination: false,
            showModal: false,
        };
        this.viewCommand = this.viewCommand.bind(this);
        this.changeSearch = this.changeSearch.bind(this);
        this.changePage = this.changePage.bind(this);
        this.changeOrderBy = this.changeOrderBy.bind(this);
        this.changeRowsPerPage = this.changeRowsPerPage.bind(this);
    }

    componentDidMount = () => {
        this.setState({ isLoading: true });
        this.props.fetchLogosRequest({
            LimitParam: 10,
            OffsetParam: 0,
            OrderByFieldParam: this.state.sortBy,
            SortOrderParam: this.state.currentSortOrder.defaultSort,
            SearchParam: ''
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.logoList && nextProps.logoList != this.props.logoList && nextProps.loading == false) {
            this.setState({ isLoading: nextProps.loading });
        }
        if (nextProps.saveLogoDetailResponse) {
            if (nextProps.saveLogoDetailResponse && nextProps.saveLogoDetailResponse != this.props.saveLogoDetailResponse) {
                if (nextProps.saveLogoDetailResponse.success) {
                    this.setState({ isSaveLogo: false });
                    this.logoAlert(nextProps.saveLogoDetailResponse.message, 'success');
                }
                else {
                    this.setState({ isSaveLogo: false });
                    this.logoAlert(nextProps.saveLogoDetailResponse.message, 'failure');
                }
            }
        }
    }

    viewCommand = (userid, status) => {
        const getAlert = () => (
            <SweetAlert
                // warning
                customClass='user-sweetalert'
                title="Transaction for Paul McMullan @User Edit"
                onConfirm={() => this.hideModel()}>
                <code>DECLARE @return_value int EXEC @return_value = [dbo].[PortalSelectQueries] @ModuleName = N'GetUserByID', @LoggedInUserID = 5, @IsSuperAdmin = NULL, @Search = '13', @OrderByFieldParam = '', @SortOrderParam = '', @LimitParam = 10, @OffsetParam = 0 SELECT 'Return Value' = @return_value</code>
            </SweetAlert>
        )

        this.setState({
            alert: getAlert(),
            showModal: !this.state.showModal,
        })
    };

    hideModel = () => {
        this.setState({
            alert: '',
            showModal: !this.state.showModal,
        })
    }

    changeSearch = (event) => {
        if (!event.target.value || event.target.value == '' || (event.target.value && event.target.value.length > 3)) {
            this.setState({ isLoading: true })
            this.setState({ textToSearch: event.target.value, rowsToSkip: 0 });
            this.props.fetchLogosRequest({
                LimitParam: this.state.rowsPerPage,
                OffsetParam: this.state.rowsToSkip,
                OrderByFieldParam: this.state.sortBy,
                SortOrderParam: this.state.currentSortOrder.defaultSort,
                SearchParam: event.target.value
            });
        }
    }

    changePage = async (event) => {
        this.setState({ isLoading: true })
        await this.setState({
            currentPage: event + 1,
            rowsToSkip: parseInt(event) > 0 ? parseInt(event) * parseInt(this.state.rowsPerPage) : 0
        });
        this.props.fetchLogosRequest({
            LimitParam: this.state.rowsPerPage,
            OffsetParam: this.state.rowsToSkip,
            OrderByFieldParam: this.state.sortBy,
            SortOrderParam: this.state.currentSortOrder.defaultSort,
            SearchParam: this.state.textToSearch
        });
    }

    changeOrderBy = async (orderedColumnId, orderDirection) => {
        let sortBy = '';
        if (orderedColumnId === 3) {
            sortBy = 'isSleepScreenerEnabled';
        }
        else {
            sortBy = orderedColumnId == 1 ? 'nickName' : "referral";
        }
        await this.setState({ isLoading: true, currentPage: 1, rowsToSkip: 0, sortBy: sortBy, currentSortOrder: { defaultSort: orderDirection ? orderDirection : 'asc' } });
        await this.props.fetchLogosRequest({
            LimitParam: this.state.rowsPerPage,
            OffsetParam: this.state.rowsToSkip,
            OrderByFieldParam: sortBy,
            SortOrderParam: orderDirection ? orderDirection : 'asc',
            SearchParam: this.state.textToSearch
        });
    }

    changeRowsPerPage = async (event) => {
        await this.setState({ rowsPerPage: event });
    }

    render() {
        const { showModal } = this.state;

        return (
            <>
                {
                    showModal ? (
                        <Modal>
                            {this.state.alert}
                        </Modal>
                    ) : null
                }

                <Helmet>
                    <title>Referral Management | Scorecard</title>
                </Helmet>
                <div className="main-content-body UserList">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-3 left-side-bar">
                                <MenuLeftNav isExpand={{ expand: "logos", active: "logos" }}></MenuLeftNav>
                            </div>
                            <div className="col-lg-9 mt-3 right-content-wrap  mb-5">
                                <div className="order-and-adherence-detail">
                                    <span className="manage-user-title">Referral Management</span>
                                    <div className="font-500 user-list-table">
                                        <div className="form-inline p-3 jc-between" style={{ height: '65px' }}>
                                            <div>
                                                <span className="ml-2 font-500">Logo Listing</span>
                                            </div>
                                            <div className="user-add-btn">
                                                <input type="text" placeholder="Enter 4 characters to search..." onChange={this.changeSearch} className="form-control mb-3" style={{ width: '230px' }} />
                                            </div>
                                        </div>
                                        <Divider />
                                        <div className="row p-3">
                                            <div className="col-lg-12">
                                                <div className="logos-listing" style={{ maxWidth: '100%' }}>
                                                    <MaterialTable
                                                        icons={tableIcons}
                                                        onChangePage={this.changePage}
                                                        onOrderChange={this.changeOrderBy}
                                                        onChangeRowsPerPage={this.changeRowsPerPage}
                                                        className="client-listing"
                                                        columns=
                                                        {[
                                                            {
                                                                title: 'Referral', field: 'referral', ...this.state.currentSortOrder,
                                                                render: rowData => {
                                                                    return rowData.referral ? rowData.referral : '-';
                                                                }
                                                            },
                                                            {
                                                                title: 'Organization Name', field: 'nickName',
                                                                render: rowData => {
                                                                    return rowData.nickName ? rowData.nickName : '-';
                                                                }
                                                            },
                                                            {
                                                                title: 'Logo', field: 'logo', sorting: false, render: rowData => {
                                                                    if (!rowData || !rowData.logo_path)
                                                                        return "-"
                                                                    return <img className="logo-img" src={`${process.env.REACT_APP_API_IMAGE_URL}/Content/Logo_Image/${rowData.logo_path}`} />
                                                                }
                                                            },
                                                            {
                                                                title: 'Sleep Screener Link', field: 'isSleepScreenerEnabled',
                                                                customSort: (rowData) => rowData.isSleepScreenerEnabled - rowData.isSleepScreenerEnabled,
                                                                render: rowData => {
                                                                    if (rowData && rowData.isSleepScreenerEnabled === "1") {
                                                                        return <FontAwesomeIcon icon={["fas", "check"]} className="text-center" color="green" />
                                                                    }
                                                                    else {
                                                                        return "-"
                                                                    }
                                                                }
                                                            },
                                                        ]}
                                                        localization={{
                                                            body: {
                                                                emptyDataSourceMessage: this.state.isLoading == true
                                                                    ? "Loading..." : "No logo to display"
                                                            }
                                                        }}
                                                        data={this.props.logoList}
                                                        page={this.state.currentPage - 1}
                                                        totalCount={this.props.totalRecords}
                                                        isLoading={this.state.isLoading}
                                                        options={{
                                                            padding: "dense",
                                                            showTitle: false,
                                                            toolbar: false,
                                                            actionsColumnIndex: -1,
                                                            search: false,
                                                            draggable: false,
                                                            pageSize: 10,
                                                            cellStyle: {
                                                                padding: "10px",
                                                                color: '#575962',
                                                                fontSize: "13px"
                                                            },
                                                            headerStyle: {
                                                                backgroundColor: '#f4f3f8',
                                                                color: '#575962',
                                                                padding: "15px 10px",
                                                                fontSize: "13px"
                                                            },
                                                            pageSizeOptions: [5, 10, 20, 50, 100]
                                                        }}
                                                        actions={[
                                                            {
                                                                icon: () => { return <FontAwesomeIcon icon={["fas", "edit"]} size='lg' /> },
                                                                tooltip: 'Edit',
                                                                hidden: !checkModulePermission('edit-logo'),
                                                                onClick: (event, rowData) => {
                                                                    localStorage.setItem('referralNameToBeEdited', (rowData.referral ? rowData.referral : '-'));
                                                                    localStorage.setItem('referralTypeToBeEdited', (rowData.referralType  ? rowData.referralType  : '-'));
                                                                    this.props.history.push('/logo/edit/' + rowData.referralKey + '/' + rowData.nickName);
                                                                }
                                                            },
                                                        ]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        logoList: state.auth.fetchLogosResponse != undefined && state.auth.fetchLogosResponse.liLogoResponse != undefined && state.auth.fetchLogosResponse.liLogoResponse.length > 0 ? state.auth.fetchLogosResponse.liLogoResponse : [],
        totalRecords: state.auth.fetchLogosResponse != undefined ? state.auth.fetchLogosResponse.listCount : 0,
        loading: state.auth.loading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchLogosRequest: ({
            LimitParam,
            OffsetParam,
            OrderByFieldParam,
            SortOrderParam,
            SearchParam
        }) => dispatch(auth.actions.fetchLogosRequest({
            LimitParam,
            OffsetParam,
            OrderByFieldParam,
            SortOrderParam,
            SearchParam
        }))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Logos);
